<template>
	<div class="shpaddedit">
				
				<b-modal id="my-model" :title="(selectedItem.id > 0)?'Edit Product':'Add Product'" size="md" ok-only @hidden="resetSelectedItem" @ok="modalSubmit" class="editaddModel" no-close-on-backdrop>
				<!-- <single-file/>
				<multiple-files/>
				<select-files/>
				<file-progress/>
				<drag-and-drop/>
				<drag-and-drop-instant/>
				<single-image-preview/>
				<multiple-images-preview/>
				<audio-preview/>
				<video-preview/>-->
				<!--<csv-preview/>
				<preview-csv/> -->
				<form ref="form" @submit.stop.prevent="handleSubmit" enctype="multipart/form-data">
					<b-container fluid>
								<b-row class="mb-1">
										<b-col cols="12">
											<b-row class="mb-3 mr-5">
												
												<b-col >
												
												
													<b-form-group label-for="title-input" label-size="sm" label-class="mb-2" class="mb-1" :state="selectedItemState.title" invalid-feedback="Title is required!" label-cols-sm="3" content-cols-sm label="*Video Title" >
													<b-form-input id="title-input" :state="selectedItemState.title" v-model="selectedItem.title" @focusin="selectedItemState.title = null" size="sm"></b-form-input>
													</b-form-group>
												</b-col>
											</b-row>
											
											<b-row class="mb-3 mr-5">
												<b-col>
													<b-form-group label-for="short_description-input" label-size="sm" label-class="mb-2" class="mb-1" :state="selectedItemState.short_description" invalid-feedback="This is required!" label-cols-sm="3" content-cols-sm label="Description" >
													<b-form-textarea id="short_description-input" :state="selectedItemState.short_description" v-model="selectedItem.short_description" @focusin="selectedItemState.short_description = null" size="sm" :maxlength="250" ></b-form-textarea>
													</b-form-group>
													<small class="float-right">{{250-selectedItem.short_description.length}}/250 Character Remaining</small>
												</b-col>
											</b-row>
											<b-row class="mb-3 mr-5">
												<b-col >
													<b-form-group label-for="sku-input" label-size="sm" label-class="mb-2" class="mb-1" :state="selectedItemState.sku" invalid-feedback="Product Tag is required!" label-cols-sm="3" content-cols-sm label="SKU" >
													<b-form-input id="sku-input" :state="selectedItemState.sku" v-model="selectedItem.sku" @focusin="selectedItemState.sku = null" size="sm" placeholder="Product SKU" ></b-form-input>
													</b-form-group>
												</b-col>
											</b-row>
											<b-row class="mb-3 mr-5">
											<b-col >
												<b-form-group :state="selectedItemState.brand"  label-for="brand-input" label-size="sm" label-class="mb-2" class="mb-1" invalid-feedback="Brand is required!" label-cols-sm="3" content-cols-sm label="*Brand">
												<b-form-select v-model="selectedItem.brand" id="status-input" :state="selectedItemState.brand" v-on:change="selectedItemState.brand = null" size="sm">
												<b-form-select-option value="" hidden selected placeholder="Brand">*Select Brand</b-form-select-option>
												<b-form-select-option v-for="option in brandlist" :key="option.id" :value="option.id">{{option.brand_name}}</b-form-select-option>
												</b-form-select>
												</b-form-group>									
											</b-col>
										</b-row>
												
											
											<b-row class="mb-3 mr-5">
												<!-- <b-col cols="2" class="text-right">
												
												<label class="font-sm">Category</label> </b-col>-->
												<b-col >
													<!-- <b-form-select v-model="selectedItem.category" :options="filteredCategory" size="sm" required></b-form-select> -->
													
													<b-form-group :state="selectedItemState.category"  label-for="category-input" label-size="sm" label-class="mb-2" class="mb-1" invalid-feedback="Category is required!" label-cols-sm="3" content-cols-sm label="*Category">
													
													<b-form-select v-model="selectedItem.category"   id="category-input" :state="selectedItemState.category" v-on:change="selectedItemState.category = null" size="sm" :options="filteredCategory" >
													</b-form-select>
													
												</b-form-group>
													
													<!-- <multiselect v-model="valueSelect" :options="optionsSel" :multiple="true"></multiselect> -->
													
													
									<!-- <label class="typo__label">Simple select / dropdown</label>
								  <multiselect v-model="valueSelect" :options="optionsSel" :multiple="true" :close-on-select="false" :clear-on-select="false" :preserve-search="true" placeholder="Pick some" label="name" track-by="name" :preselect-first="true">
									<template slot="selection" slot-scope="{ values, search, isOpen }"><span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} options selected</span></template>
								  </multiselect> -->
								  <!-- pre class="language-json"><code>{{ valueSelect  }}</code></pre> -->
																						
										</b-col>
									</b-row>
											
									<b-row class="mb-3 mr-5">
												
												<b-col >
													<!--<input type="file" ref="file"  @change="handleFileUpload()"/> -->
													<b-form-group label-for="product_image_1-input" label-size="sm" label-class="mb-2" class="mb-1" :state="product_infState.product_image_1" invalid-feedback="Video is required!" label-cols-sm="3" label="* Video">
												<input type="file" ref="file"  @change="handleFileUpload()" />
												<!--<b-form-file type="file" size="sm" placeholder="Choose a Video"  ref="file"  @change="handleFileUpload()"></b-form-file>-->
												
												</b-form-group>	
												
											<!--<b-form-group label-for="product_image_1-input" label-size="sm" label-class="mb-2" class="mb-1" :state="product_infState.product_image_1" invalid-feedback="Image is required!" label-cols-sm="3" label="* Video">
													<b-form-file type="file" v-model="product_inf.product_image_1"  size="sm" placeholder="Choose a Video" id="product_image_1-input" :state="product_infState.product_image_1" @focusin="product_infState.product_image_1 = null" ></b-form-file>
												</b-form-group>	 -->							
										</b-col>
									</b-row>
									
									

											<!--<b-row class="mb-3 mr-5">
												
												<b-col>
												<b-form-group label-for="min_qty-input" label-size="sm" label-class="mb-2" class="mb-1" label-cols-sm="3" content-cols-sm label="Minimum Qty" >
												<b-form-input id="min_qty-input"  v-model="selectedItem.product_data.min_qty"  size="sm" placeholder="eq. 5" @keypress="onlyNumber" maxlength="2"></b-form-input>
												</b-form-group>
												</b-col>
											</b-row>-->
										</b-col>
									</b-row>

					
						
					</b-container>
				</form>
				<template  v-slot:modal-footer="{ ok, close }">
					<b-button size="sm" variant="danger" @click="close()" style="display:none;">Cancel</b-button>
					
					 <!--<b-button size="sm" variant="success" @click="ok()">{{(selectedItem.id > 0)?'Update':'Submit'}}</b-button> -->
					
					 
					 <b-button size="sm" variant="success" @click="modalSubmit">{{(selectedItem.id > 0)?'Update':'Submit'}}</b-button>
					
				
						<!-- {{ tabIndex }}
						{{selectedItem.product_type}} -->
						
						
				</template>
				<transition name="fade">
			<b-row v-if="loading" class="loading" style="position: absolute; top:0px; left:0px; right:0px; bottom:0px; z-index: 1000; background-color: rgba(0,0,0,0.4);" align-v="center" align-h="center">
				<b-spinner label="Busy" variant="light"></b-spinner>
			</b-row>
		</transition>
			</b-modal>

		

	</div>		
</template>
<script>

/* setpassword

http://localhost:8080/agent/dashboard/setpassword*/

//import CartVariant from "@/components/cartVariant.vue";
//import ProductRating from "@/components/product-rating.vue";
/*import SingleFile from '@/components/videos/SingleFile.vue'
import MultipleFiles from '@/components/videos/MultipleFiles.vue';
import SelectFiles from '@/components/videos/SelectFiles.vue';
import FileProgress from '@/components/videos/FileProgress.vue';
import DragAndDrop from '@/components/videos/DragAndDrop.vue';
import DragAndDropInstant from '@/components/videos/DragAndDropInstant.vue';
import SingleImagePreview from '@/components/videos/SingleImagePreview.vue';
import MultipleImagesPreview from '@/components/videos/MultipleImagesPreview.vue';
import AudioPreview from '@/components/videos/AudioPreview.vue'; 
import PreviewCsv from '@/components/videos/PreviewCsv.vue';*/
//import VideoPreview from '@/components/videos/VideoPreview.vue';


export default {
  name: 'ShareEmailPopupsdd',
  components: {
  //"cart-variant": CartVariant,
  //"product-rating": ProductRating,
	/*SingleFile,
	MultipleFiles,
	SelectFiles,
	FileProgress,
	DragAndDrop,
	DragAndDropInstant,
	SingleImagePreview,
	MultipleImagesPreview,
	AudioPreview,
	PreviewCsv, */
	//VideoPreview,
	
  
  },
  props: { 
	//selectedItem: { type: Object },	
	filteredCategory: { type: Array },	
	category: { type: Array },	
	brandlist: { type: Array },	
	sizelist: { type: Array },	
  },
  mounted(){
    this.inLodcard();
  },
  computed: {
    
  },
  data() {
    return{
			loading: false, 
            thumbnailProps: { blank: false, width: 60, height: 60, class: 'm1' },           
			product_inf: {},
			file: '',
			product_infState: {product_image_1:null,
						  product_image_2:null,
						  product_image_3:null,
						  product_image_4:null,
						  product_image_5:null,
						  },
			product_inforder: {
					order_1:1,
					order_2:2,
					order_3:3,
					order_4:4,
					order_5:5},
		updateUrl: this.$root.WEBAPI+'secureapi/productstatus-update',
		insertnewUrl: this.$root.WEBAPI+'webapi/uploadVideo',
		updateProUrl: this.$root.NEWAPIURL+'sellerapi/productupdatenew',
		//insertnewUrl: this.$root.NEWAPIURL+'sellerapi/productinsertnew',
		//insertnewUrl: this.$root.NEWAPIURL+'sellerapi/videoinsertnew',
		 selectedItem: {
				title: '',
				short_description: '',
				sku: '',
				category: '',
				gallery_images:["","","",""],
				status:'',
				brand:'',
			},
			selectedItemState: {
				title: null,
				short_description: null,			
				sku: null,				
				category: null,				
				tier_price:null, 
				status:null,
				brand:null,
			},
			emptyItem: {
				id: 0,
				product_id: '',
				title: '',
				short_description: '',
				description: '',
				sku: '',
				hsn_code: '',
				category: '',
				price: '',
				product_type: 1,
				stock_qty:'',
				stock_status:'',
				special_price: '',
				product_data:{},
				tier_price: [],
				gallery_images:["","","","",""],
                status: 0,
                commission: '',
				variation_attributes:[],
				variations:[],
				brand:'',
				selectedOption:[]
			},
			counterindex:1,
			deleteImage1:'',
			deleteImage2:'',
			deleteImage3:'',
			deleteImage4:'',
			deleteImage5:'',
			tabIndex: 0,
			commissionError:'Commission is required!',
			selectMode: 'multi',
			selected: [],
			sellerList: [],
			reg_brand:null,
			valueSelect:[],
			optionsSel:[],
		
		
    }
  },
  methods:{
	/* inLodcard(){
		alert('dasd');
	},*/
	inLodcard(){			
			//this.linkComments = this.social_options[this.$root.share.social];
		},
		checkFormValidityBank() {
			//alert('tab');
			
					var valid = true;
					if(this.selectedItem.title.length < 3){
						valid = false;
						this.selectedItemState.title = false;
					}else{
						this.selectedItemState.title= true;
					}
					
					if(this.selectedItem.short_description.length < 3){
						valid = false;
						this.selectedItemState.short_description = false;
					}else{
						this.selectedItemState.short_description= true;
					}
					
					
					
					/*if(this.selectedItem.sku.length < 4){
						valid = false;
						this.selectedItemState.sku = false;
					}else{
						this.selectedItemState.sku= true;
					} */
					/* if(this.selectedItem.hsn_code==''){
					valid = false;
					this.selectedItemState.hsn_code = false;
					}else if(this.selectedItem.hsn_code.length < 4){
					valid = false;
					this.selectedItemState.hsn_code = false;
					}else{
					this.selectedItemState.hsn_code= true;
					}*/
					
					if(this.selectedItem.brand.length < 1){
						valid = false;
						this.selectedItemState.brand = false;
					}else{
						this.selectedItemState.brand= true;
					}
					
					if(this.selectedItem.category.length < 1){
						valid = false;
						this.selectedItemState.category = false;
					}else{
						this.selectedItemState.category= true;
					}
					
					/* if(this.$refs.file.files[0]==''){
						valid = false;
						this.selectedItemState.category = false;
					}else{
						this.selectedItemState.category= true;
					} */
					//console.log(this.$refs.file.files[0]);
					if(typeof this.$refs.file.files[0]==='undefined'){
							valid = false; 
							this.product_infState.product_image_1 = false;
						}else{
							this.product_infState.product_image_1= true;
						}
					
					
					/*if(this.selectedItem.product_type==''){
					valid = false;
					this.selectedItemState.product_type = false;
					}else{
					this.selectedItemState.product_type= true;
					} */
					
					
					//console.log(this.product_inf.product_image_1);
					/* if(this.selectedItem.gallery_images[0]==''){
						if(typeof this.product_inf.product_image_1==='undefined'){
							valid = false; 
							this.product_infState.product_image_1 = false;
						}else{
							this.product_infState.product_image_1= true;
						}
					} */
					
					/*
					if(this.selectedItem.brand==''){
						valid = false;
						this.selectedItemState.brand = false;
					}else{
						this.selectedItemState.brand= true;
					} */
					
				return valid;
			},

			modalSubmit(bvModalEvt){
			//return false;
					if (!this.checkFormValidityBank()) {
						return;
						}
						
					console.log('dev D');
					var self = this;
					self.loading = true;
					bvModalEvt.preventDefault();
					var submitUrl = "";
					var editAct=0;
					submitUrl = self.insertnewUrl;
					

					let formData = new FormData();
					formData.append('file', this.file);
					formData.append('imagefile1', this.product_inf.product_image_1);
					formData.append('imagefile2', this.product_inf.product_image_2);
					formData.append('imagefile3', this.product_inf.product_image_3);
					formData.append('imagefile4', this.product_inf.product_image_4);
					formData.append('imagefile5', this.product_inf.product_image_5);
					
					//formData.append('image_order', this.product_inforder);
					//this.selectedItem.image_order = this.product_inforder;
					formData.append('data', JSON.stringify(this.selectedItem));
					formData.append('accesskey', this.$session.get('access_key'));

					self.axios.post(submitUrl, formData, {
						headers: {
							//'Content-Type': 'multipart/form-data'
							'Content-Type': 'multipart/form-data'
							
							
						}
					})
					.then(function (response) {
						if(response.data.error == 0 || response.data.error == '0'){
							
							self.$bvToast.toast(response.data.message, {
								title: 'Status',
								toaster: 'b-toaster-bottom-right',
								autoHideDelay: 5000,
								variant: 'warning',
								solid: true,
								appendToast: true
							});
							if(editAct==0){
							self.$bvModal.hide('my-model');
							self.product_inf.product_image_1 = '';
							self.product_inf.product_image_2 = '';
							self.product_inf.product_image_3 = '';
							self.product_inf.product_image_4 = '';
							self.product_inf.product_image_5 = '';
							//self.initload();
							}
						}
						self.loading = false;
					})
					.catch(function (error) {
						alert(error);
					});
		},
		resetSelectedItem(){
			//var self = this;
			//self.selectedItem = Object.assign({}, self.emptyItem);
		},
		onlyRupees ($event) {
		   //console.log($event.keyCode); //keyCodes value
		   let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
		   if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) { // 46 is dot
			  $event.preventDefault();
		   }
		},
		onlyNumber ($event) {
		   //console.log($event.keyCode); //keyCodes value
		   let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
		   if(keyCode < 48 || keyCode > 57)  { // 46 is dot
			  $event.preventDefault();
		   }
		},
		imageOrderVAlidate($event) {
		   //console.log($event.keyCode); //keyCodes value
		  // console.log($event.target.value); //keyCodes value
		   
		    /*let regex = /^[0-9]*$/
			  if (!regex.test(el.value)) {
				el.value = el.value.slice(0, -1)
			  }*/
		   
		   
		   let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
		   if(keyCode < 48 || keyCode > 57)  { // 46 is dot
			  $event.preventDefault();
		   }
		},
		imageOrderVAlidateP($event) {
		   console.log($event.keyCode); //keyCodes value
		   console.log($event.target.value); //keyCodes value
		   
		    let regex = /^[1-5]*$/
			  if (!regex.test($event.target.value)) {
				$event.target.value = $event.target.value.slice(0, -1);
			  }
		   
		   /*
		   let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
		   if(keyCode < 48 || keyCode > 57)  { // 46 is dot
			  $event.preventDefault();
		   }*/
		},onChangeCommission(){
			if(this.selectedItem.commission < 5 && this.selectedItem.commission != 0){
				//this.selectedItem.commission = 5;
			}
		},filterChildCategory(id, index, parentid){
			var self = this;
			var tab = '';
			for (let i = 0; i < index; i++) {
				tab += "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;";
			}
			this.category.forEach(function(field){
				if(field.parent == id){
					var fieldid = field.id;
					if(parentid != 0){
						fieldid = parentid+','+field.id;
					}
					self.filteredCategory.push({ html: tab+field.title, title:field.title, position:field.position, parent:field.parent, value: fieldid });
					
					self.optionsSel.push({ name: tab+field.title, language:field.title,value: fieldid});
					
					self.filterChildCategory(field.id, index+1, fieldid);
				}
			});
			return ;
		},
		addVariation(){
			//console.log(JSON.stringify(this.selectedItem.tier_price));
			var d = new Date();
			var uniqid = d.getTime();
			var attributes = [];
			this.selectedItem.variation_attributes.forEach(function(attr){
				attributes.push({'id':++uniqid, 'label':attr, 'value': '', position: ''});
			});
			this.selectedItem.variations.push({'id':d.getTime(), 'sku':'', 'attributes':attributes, 'price': 0, 'special_price': 0, 'stock_qty': 1, 'stock_status': 1});
		},
		addAttribute(){
			var d = new Date();
			if(this.selectedItem.variation_attributes.length < 3){
				this.selectedItem.variation_attributes.push("");
				this.selectedItem.variations.forEach(function(variation){
					variation.attributes.push({"id":d.getTime(),"label":"","value":"","position":variation.attributes.length+1});
				});
			}
		},
		handleFileUpload(){
				//this.file = event.target.files[0];
				this.file = this.$refs.file.files[0];
				
				//this.previewVideo();
			},
		

    
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style   lang="scss">
	
	.disabledTab{
      pointer-events: none;
	}
	.mytabpae{
		/*border:1px solid red;*/
		.nav-link{
		font-size:11px !important;
		}
	}
	.modal-body{
		padding-bottom: 0px;
	}
	.modal-header{
				padding-top:3px !important;
				padding-bottom:3px !important;
			}
			
	.modal-footer{		
			padding-top: 2px;
			padding-bottom: 3px;
			padding-right: 10%;
	}
	.editaddModel{
			
	}
	
	.col-sm-48{
	margin-right: 29%;
	}.col-sm-49{
	margin-right: 7%;
	}
	
	
	


</style>
